import ICON__trash from '@/assets/icons/font_awesome/trash-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_8_3 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_3';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_equal, assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__list_base_generic } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_base_generic';
import { useMemo, useRef } from 'react';

interface PROPS {
  field: FIELD__base;
}

export function G_BUTTON__graph_field_list_item_remove({ field }: PROPS) {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_graph__field_hovered } = use_slice_ui(['g_graph__field_hovered']);
  const { graph } = generation_current.tool;

  /*
   * STATE
   */

  const is_removed = useRef(false);

  const is_hovered = useMemo(() => {
    return g_graph__field_hovered.field_id === field.meta.field_id;
  }, [g_graph__field_hovered.field_id, field.meta.field_id]);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();

    is_removed.current = true;

    assert_equal(graph.meta.graph_id, field.meta.graph_id);

    let parent_new = get_field_parent().clone();

    //remove item
    parent_new.item_remove(field);

    let graph_new = graph.clone();
    graph_new.field__replace(parent_new);

    await UTILS__graph_data.update(graph_new);
  }
  /*
   * METHODS
   */
  function get_field_parent() {
    let parent = graph.field__get_parent(field.meta);
    assert_instanceof(parent, FIELD__list_base_generic);
    return parent;
  }

  /*
   * HTML
   */

  if (is_removed.current) return <PLACEHOLDER_BUTTON__bar_8_3 />; //need to avoid bug when item already removed and we cant reach parent from graph
  if (get_field_parent().buttons_add_remove_are_disabled) return <PLACEHOLDER_BUTTON__bar_8_3 />;
  if (graph.meta.graph_id !== field.meta.graph_id) return <PLACEHOLDER_BUTTON__bar_8_3 />;
  if (!is_hovered) return <PLACEHOLDER_BUTTON__bar_8_3 />;

  return (
    <UI_PRIMITIVE__button size={'rect-8-3'} variant={'no-border-on-component'} {...{ onClick }} title="Remove item">
      <ICON__trash className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
